/**
 * Horizontal padding for every section of the confirm card. Matches the `marginLeft: 24`
 * that `OrderItemRow` hardcodes on its thumbnail (OrderItemRow.tsx:127) so the unpadded
 * item list lines up with the padded sections around it.
 */
export const CARD_PADDING = 24;

/** Breathing room above and below the card, matching the web overlay's vertical padding. */
export const CARD_MARGIN = 24;
